import React, { useState } from "react";
import "./whatsappForm.css"
import { sendWhatsAppMessageAPI } from "../BranchSettingsAPI";

function SendMessageForm({ userId }) {
  const [phoneNumber, setPhoneNumber] = useState("");
  const [message, setMessage] = useState("");
  const [file, setFile] = useState(null);
  const [status, setStatus] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSend = async (e) => {
    e.preventDefault();
    setStatus("Sending...");
    const formData = new FormData();
    formData.append("userId", userId);
    formData.append("phoneNumber", phoneNumber);
    formData.append("message", message);
    if (file) formData.append("file", file);

    const result = await sendWhatsAppMessageAPI(formData, setStatus, setLoading);
  };

  return (
    <form onSubmit={handleSend}>
      <h4>Send WhatsApp Message</h4>
      <input
        type="text"
        placeholder="Phone Number"
        value={phoneNumber}
        onChange={(e) => setPhoneNumber(e.target.value)}
        required
      />
      <br />
      <textarea
        placeholder="Message"
        value={message}
        onChange={(e) => setMessage(e.target.value)}
        required
      />
      <br />
      <input
        type="file"
        accept="image/*,application/pdf,video/*"
        onChange={(e) => setFile(e.target.files[0])}
      />
      <br />
      <button type="submit" disabled={loading}>{loading ? "Sending..." : "Send"}</button>
      <div>{status}</div>
    </form>
  );
}

export default SendMessageForm;